




















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { StudentInfo } from "../../_models/studentInfo";
import CardTitle from "../CardTitle.vue";
import DetailsInfo from "../Details/DetailsInfo.vue";
import EditDialog from "../Edit/EditDialog.vue";
import ChagePassword from "../ChangePassword.vue";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module"
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import WelcomeDialog from "../../components/Dialogs/WelcomeDialog.vue"

@Component({
  components: {
    CardTitle,
    DetailsInfo,
    EditDialog,
    ChagePassword,
    WelcomeDialog
  }
})
export default class StudentDetails extends Vue {
  @Prop() studentInfo!: StudentInfo;
  @Prop() checkComplete!: boolean;
  private titleParams: object;
  private studentData: StudentInfo;
  private ruolo: number[];
  private isComplete: boolean;

  private welcomeDialog: boolean

  constructor() {
    super();
    this.titleParams = {
      title: "Dati Personali",
      cols: "12",
      sm: "6",
      md: "5",
      lg: "4"
    };
    this.isComplete = false;
    this.studentData = {
      tipoSoggetto: this.studentInfo.tipoSoggetto,
      matricola: this.studentInfo.matricola,
      ruoloUtente: this.studentInfo.ruoloUtente,
      descrizioneRuolo: this.studentInfo.descrizioneRuolo,
      nomeUtente: this.studentInfo.nomeUtente,
      cognomeUtente: this.studentInfo.cognomeUtente,
      indirizzoUtente: this.studentInfo.indirizzoUtente,
      telefono1Utente: this.studentInfo.telefono1Utente,
      telefono2Utente: this.studentInfo.telefono2Utente,
      cod: this.studentInfo.cod,
      dataNascita: this.studentInfo.dataNascita,
      luogoNascita: this.studentInfo.luogoNascita,
      emailUtente: this.studentInfo.emailUtente,
      pecUtente: this.studentInfo.pecUtente,
      comuneUtente: this.studentInfo.comuneUtente,
      provinciaUtente: this.studentInfo.provinciaUtente,
      entità: this.studentInfo.entità,
      codEntità: this.studentInfo.codEntità,
      idCap: this.studentInfo.idCap,
      idUtente: this.studentInfo.idUtente,
      cap: this.studentInfo.cap,
      username: this.studentInfo.username,
      classe: this.studentInfo.classe,
      idClasse: this.studentInfo.idClasse,
      idNazioneNascita: this.studentInfo.idNazioneNascita,
      diplomato: this.studentInfo.diplomato,
      dataDiploma: this.studentInfo.dataDiploma,
      urlCV: this.studentInfo.urlCV
    };

    this.welcomeDialog = false
    // this.studentData = {
    //   tipoSoggetto: 0,
    //   matricola: "",
    //   ruoloUtente: [],
    //   descrizioneRuolo: [],
    //   nomeUtente: "",
    //   cognomeUtente: "",
    //   indirizzoUtente: "",
    //   telefono1Utente: "",
    //   telefono2Utente: "",
    //   cod: "",
    //   dataNascita: "",
    //   luogoNascita: "",
    //   emailUtente: "",
    //   pecUtente: "",
    //   comuneUtente: "",
    //   provinciaUtente: "",
    //   entità: "",
    //   codEntità: 0,
    //   idCap: 0,
    //   idUtente: 0,
    //   cap: "",
    //   username: "",
    //   classe: "",
    //   idClasse: 0
    // };
    this.ruolo = [];
  }

  searchStateName() {
    data
      .dispatchStatiList(this["$store"])
      .then(() => {
        var states = data.readStatiList(this["$store"]);
        // var stateName: string = "";
        states.forEach(element => {
          if (element.idStato === this.studentData.idNazioneNascita) {
            bus.$emit("stateName", element.nomeStato);
          }
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  searchComuneName() {
    var payload = {
      località: "",
      provincia: ""
    }
    data
      .dispatchComuniList(this["$store"])
      .then(() => {
        var comuni = data.readComuniList(this["$store"]);
        comuni.forEach(element => {
          if (element.id === this.studentData.idCap) {
            payload.località = element.località
            payload.provincia = element.idProvincia
            bus.$emit("comuneName", payload);
          }
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    // var token = localStorage.getItem("userToken");
    // var parsedToken: any;
    // if (token !== null) {
    //   parsedToken = userUtils.parseToken(token);
    // }
    // var payload = {
    //   idUtente: parsedToken.IdUtente,
    //   tipoSoggetto: parsedToken.IdTipoSoggetto,
    //   username: parsedToken.Username
    // };

    // user.dispatchSetStudentInfo(this["$store"], payload).then(() => {
    // this.studentData = user.readStudentInfo(this["$store"]);
    var userStatus = localStorage.getItem("userStatus");
    this.isComplete = userUtils.checkStudentInfo(this.studentData);
    if (
      this.checkComplete !== undefined &&
      this.checkComplete === true &&
      userStatus !== undefined && userStatus !== "5"
    ) {
      if (this.isComplete === false) {
        bus.$emit("incompleteInfo");
      }
    }
    this.searchStateName()
    this.searchComuneName()
    // });

    bus.$on("editedStudent", () => {
      this.studentData = user.readStudentInfo(this["$store"]);
      this.searchStateName()
      this.searchComuneName()
    });

    bus.$on("openWelcomeDialog", () =>{
      bus.$emit("openWelcome","student")
    })
  }

  mounted() {
    var userInfo: StudentInfo = user.readStudentInfo(this["$store"]);
    this.ruolo = userInfo.ruoloUtente;
  }
}
